import React from 'react';
import { connect } from "react-redux";
import { Col, Row, Form } from "react-bootstrap";
import style from './Search.module.scss';
import Select from "react-select";
import {reactSelectStyle} from "../../../../helper/reactSelect";
import * as regionActions from '../../../../redux/action/region.action';
import history from "../../../../helper/history";

class Search extends React.Component {
  constructor(props) {
    super(props);    
    this.state = {
      selectedOption: 'SELL',
      selectedRegions: [],
      regions: []
    };
  };

  componentDidMount() {
    this.fetchRegionsByState();
    const filteredRegions = this.props.filter.region.split(',');
    this.setState({ selectedRegions: filteredRegions });
  }

  async fetchRegionsByState(state) {
    const response = await this.props.findRegionByState(state);
    await this.setState({regions: response.map((item) => {
        return { value: item.id, label: item.title }
      })
    });
  }

  onValueChange = function (value) {
    this.setState({
      selectedOption: value
    });
  };

  redirect() {
    const {selectedRegions, selectedOption} = this.state;
    history.push(`/advanced-search?transactionType=${selectedOption}${selectedRegions && selectedRegions.length ? `&region=${selectedRegions.join(',')}` : ''}`);
  }


  render() {
    const { selectedRegions, selectedOption } = this.state;

    return (
      <Row className={'d-flex align-items-end'}>
        <Col className={'d-none d-md-block'} />
        <Col xs={12} md={7} className={`text-right ${style.search_container}`}>
          <h1 className={`${style.header}`}>انتخاب خوب هنر است</h1>
          <h3 className={style.title}>در بین بیش از صد هزار ملک بهترین انتخاب را داشته باشید</h3>
          <div className={`${style.search_card}`}>
            <Form>
              <div className={`${style.search_regions} ${style.filter} ${selectedOption === 'SELL' ? style.buy : style.rent}`}>
                <label className={`${style.input_label} ${style.input_rent} position-relative ${selectedOption === 'SELL' ? style.not_active : ''}`} onClick={()=> { this.onValueChange('RENT') }}>رهن یا اجاره</label>
                <label className={`${style.input_label} position-relative ${selectedOption === 'RENT' ? style.not_active : ''}`} onClick={()=> { this.onValueChange('SELL') }}>خرید</label>
                <div className={`d-flex flex-row-reverse align-items-center position-relative ${style.region_input_container}`}>
                  <div className={`d-flex align-items-center justify-content-end pr-2 ${style.region_input}`}>
                    <i className={`icon-search ${style.search_icon} ml-2`}  onClick={() => { this.redirect() }}/>
                    <Select
                        placeholder="نام محله مورد نظر خود را وارد کنید"
                        className="react-select"
                        closeMenuOnSelect={true}
                        styles={reactSelectStyle}
                        isMulti={true}
                        isRtl={true}
                        isClearable={false}
                        onChange={(newValue) => {
                          this.setState({selectedRegions: newValue ? newValue.map((v) => v.value) : []});
                        }}
                        value={this.state.regions ? this.state.regions.filter((opt) => selectedRegions.find((state) => state === opt.value)) : ''}
                        options={this.state.regions}
                    />
                    <span className={`${style.state} pl-3 pr-2`}>تهران</span>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: state.property.filter
});

const mapDispatchToProps = (dispatch) => ({
  findRegionByState: (state) => dispatch(regionActions.findRegionByState(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
